import { c as _c } from "react/compiler-runtime";
import React from 'react';
import StandardModal from 'components/consumer/StandardModal';
import avo from 'analytics/avo';
import Link from 'components/consumer/Link';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const PDPShowroomModal = t0 => {
  const $ = _c(36);
  const {
    data: t1,
    isOpen,
    onClose
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  let t3;
  if ($[2] !== data?.name || $[3] !== data?.url) {
    t3 = () => {
      avo.ctaClicked({
        text: data?.name,
        targetUrl: data?.url,
        cta: "Retail Store",
        location: "PDP"
      });
      window.open(data?.url, "_blank");
    };
    $[2] = data?.name;
    $[3] = data?.url;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const showroomClicked = t3;
  const t4 = data?.name;
  let t5;
  if ($[5] !== t4) {
    t5 = <h2 className="mb-8">{t4}</h2>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h4 className="text-lg font-bold mb-4">Store Hours</h4>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== data?.hours) {
    t7 = data?.hours.map(_temp);
    $[8] = data?.hours;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div className="flex justify-start items-start flex-col">{t6}{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = data?.name === "Virtual Showroom" ? "Questions about this product?" : "Location";
  let t10;
  if ($[12] !== t9) {
    t10 = <h4 className="text-lg font-bold mb-4">{t9}</h4>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== data?.location || $[15] !== data?.locationUrl || $[16] !== data?.name) {
    t11 = data?.name !== "Virtual Showroom" && <Link to={data?.locationUrl} className="text-sm text-brand font-bold border-0 cursor-pointer bg-transparent no-underline" openExternalInNewTab={true}>{data?.location}</Link>;
    $[14] = data?.location;
    $[15] = data?.locationUrl;
    $[16] = data?.name;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = data?.calendly;
  const t13 = data?.name === "Virtual Showroom" ? "Chat with a Design Consultant" : "Book a Virtual Appointment";
  let t14;
  if ($[18] !== t12 || $[19] !== t13) {
    t14 = <CtaLink size="base" color="brand" styling="solid-button" to={t12} className="mx-0 my-[1.4rem]">{t13}</CtaLink>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== showroomClicked) {
    t15 = <button type="button" className="text-sm text-brand font-bold border-0 cursor-pointer bg-transparent no-underline" onClick={showroomClicked} aria-label="Browse products in Showroom">Browse products on display here</button>;
    $[21] = showroomClicked;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t14 || $[26] !== t15) {
    t16 = <div className="flex justify-start items-start flex-col pl-8 max-[767px]:pt-8 max-[767px]:px-0 max-[767px]:pb-0">{t10}{t11}{t14}{t15}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16 || $[29] !== t8) {
    t17 = <div className="flex justify-start items-start max-[767px]:flex-col">{t8}{t16}</div>;
    $[28] = t16;
    $[29] = t8;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== isOpen || $[32] !== onClose || $[33] !== t17 || $[34] !== t5) {
    t18 = <StandardModal className="PDPShowroomModal" isOpen={isOpen} theme="light" onClose={onClose}>{t5}{t17}</StandardModal>;
    $[31] = isOpen;
    $[32] = onClose;
    $[33] = t17;
    $[34] = t5;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};
PDPShowroomModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func
};
export default withBrowserOnly(PDPShowroomModal);
function _temp(x) {
  return <p className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray-light2 whitespace-nowrap leading-[1.4rem]">{x}</p>;
}